import { render } from "./Lake.vue?vue&type=template&id=5b4819ec&scoped=true"
import script from "./Lake.vue?vue&type=script&lang=js"
export * from "./Lake.vue?vue&type=script&lang=js"

import "./Lake.vue?vue&type=style&index=0&id=5b4819ec&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4819ec"]])

export default __exports__